import { Injectable } from '@angular/core';
import { DatabaseGwService } from '../database-gw.service';

@Injectable({
  providedIn: 'root'
})
export class InvoiceWithOrderService extends DatabaseGwService {
  URL_PATH: string = "/invoice-sale-order";
}
